module.exports = __webpack_public_path__ + "static/media/wanderer_returns.97522747.png";